import { Component, OnInit } from '@angular/core';
import { Ticket } from './models/ticket/ticket';
import { TicketService } from './services/ticket/ticket.service';
import { UsuarioService } from './services/usuario/usuario.service';
import { Usuario } from './models/usuario/usuario';
import { NgForm } from '@angular/forms';
declare var $: any;
declare var alertify: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [TicketService, UsuarioService]
})
export class AppComponent implements OnInit {
  ticket: Ticket;
  usuario: Usuario;
  asuntos: Array<string>;

  constructor(
    private ticketService: TicketService,
    private usuarioService: UsuarioService
  ) {
    this.ticket = new Ticket('', '', '', '', '0', '', '', '', '', '');
    this.asuntos = ['SOPORTE TÉCNICO', 'PRÉSTAMO DE EQUIPOS',
                    'RESETEO DE CLAVES', 'APLICACIONES INFORMÁTICAS',
                    'INSTALACIÓN DE PROGRAMAS', 'IMPRESORAS', 'QUIPUX',
                    'REQUERIMIENTOS REGISTRO PUBLICO DEL AGUA (RPA)', 'OTRO'];
  }

  ngOnInit(): void {
    $('[data-toggle="tooltip"]').tooltip();
    alertify.defaults.transition = 'zoom';
    alertify.defaults.theme.ok = 'btn btn-dark';
  }

  getUsuario(): void {
    let usuario: string;
    if (!this.ticket.usuario) {
      usuario = 'no_existe';
    } else {
      usuario = this.ticket.usuario;
    }
    this.usuarioService.getUsuario(usuario).subscribe(
      result => {
       // console.log(result);
        if (result.code === 200) {
          this.usuario = result.data;
          this.ticket.nombre = this.usuario.nombre;
          this.ticket.email = this.usuario.email;
          this.ticket.telefono = this.usuario.telefono;
          this.ticket.extension = this.usuario.extension;
          this.ticket.sitio_ayuda = this.usuario.sitio_ayuda;
          this.ticket.area = this.usuario.area;
        } else {
          // tslint:disable-next-line:max-line-length
          alertify.alert('Advertencia!!!', 'El usuario ingresado no existe, verifique el dato ingresado o contáctese con el personal técnico de TICs de su Demarcación o de Planta Central.',
            () => {
              this.ticket.usuario = '';
              this.ticket.nombre = '';
              this.ticket.email = '';
              this.ticket.extension = '0';
              this.ticket.sitio_ayuda = '';
              this.ticket.area = '';
            }).set('label', 'Aceptar');
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  sendTicket(f: NgForm): void {
    this.ticketService.sendTicket(this.ticket).subscribe(
      result => {
        console.log(result);
        if (result.code === 200) {
          alertify.alert('Notificación!!!', 'Su ticket fue enviado correctamente.',
          () => {
            f.reset();
            this.ticket = new Ticket('', '', '', '', '0', '', '', '', '', '');
          });
        } else {
          alertify.alert('Error!!!', 'Error al enviar ticket, comuniquese con el administrador.');
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts